export default {
  affiliate: {},
  affiliates: [],
  unvaluedAffiliates: [],
};
